<ng-container *ngIf="(maxAdd || maxAdd === 0) && learnerCount > maxAdd">
  <p-message severity="error" [text]="tooManyLearnersMessage"></p-message>
</ng-container>
